import { ContractCarryOverOptions } from "@/pages/contracts/hooks";

// Contract-level fields the user can edit before the duplicate is created.
export interface DuplicateContractFields {
  companyId: string | null;
  productId: string | null;
  csmOwner: string | null;
}

export type ShiftUnit = "days" | "weeks" | "months" | "years";

export interface DateShift {
  amount: number;
  unit: ShiftUnit;
}

export const SHIFT_PRESETS: DateShift[] = [
  { amount: 1, unit: "months" },
  { amount: 6, unit: "months" },
  { amount: 1, unit: "years" },
  { amount: 2, unit: "years" },
  { amount: 3, unit: "years" }
];

export const DEFAULT_SHIFT_PRESET: DateShift = { amount: 1, unit: "years" };

export const DEFAULT_CARRY_OVER: ContractCarryOverOptions = {
  retentionWorkflowsData: true,
  onboardingStatusAndWorkflows: true,
  contractOwners: true,
  filesAndAttachments: true,
  peopleInContract: true
};
